import { useEffect, useRef, useState } from "react";
import { money } from "@/lib/format";

// Eased count-up for money values. Animates whenever `value` changes so totals
// feel alive as funds come in — a small detail that reads as hand-crafted.
export default function AnimatedMoney({ value = 0, className, testId }) {
  const [display, setDisplay] = useState(value);
  const fromRef = useRef(value);
  const rafRef = useRef(null);

  useEffect(() => {
    const start = performance.now();
    const from = fromRef.current;
    const to = Number(value) || 0;
    const dur = 650;
    if (from === to) return;

    const step = (now) => {
      const t = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
      setDisplay(from + (to - from) * eased);
      if (t < 1) rafRef.current = requestAnimationFrame(step);
      else fromRef.current = to;
    };
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value]);

  return (
    <span className={className} data-testid={testId}>
      {money(display)}
    </span>
  );
}
